export const WIKI_BASE_URL = 'https://wiki.snootsvet.com'

export const wikiPages = {
  membershipCancellation: `${WIKI_BASE_URL}/doc/cancellation-S0dAUki2dT`,
} as const
